// Single source of truth for the moratorium message — shared between the
// dashboard tile and the credit-page guard popup so they can't drift.
// Product to finalise wording.
export const MORATORIUM_TITLE = "CREDIT OPTIONS";

export const MORATORIUM_BODY_COPY =
  "Based on a recent credit application, now may not be the best time to apply for a loan. We'll let you know when your options change.";
